import React, { useEffect, useState } from "react";
import { getApiBaseUrl, authenticatedRequest } from './Utils.js'
import { useAuth } from "./AuthContext";

const About = (props) => {

  const authUser = useAuth();
  const [apiURL, setApiUrl] = useState(null);
  const [targetUser, setTargetUser] = useState("");
  const [output, setOutput] = useState("");

  useEffect(() => {
    if(authUser && authUser.access_token) {
      getApiBaseUrl(setApiUrl, authUser.access_token);
    }
  }, [authUser]);

  if (!authUser) {
    sessionStorage.setItem("app:redirect", location.href);
    window.location.replace('/');
    return null;
  }

  const checkUser = () => {
    const url = `${apiURL}/ui/groups/${targetUser}`;
    authenticatedRequest(url, authUser.access_token, (response) => {
      setOutput(JSON.stringify(response.groups));
    }, (response) => {
      alert("Error: " + response.statusText);
    });
  }

  return (
    <div>
        <div>
          <div className='text-center'>
            <div className='text-center'>
              <h4>Hello, {authUser ? authUser.profile.given_name : "[loading]"}!</h4>
            </div>
            
            <label>
                Check users groups:<input className="form-control" size={50} key={"targetUser"} value={targetUser} onChange={(ev) => { setTargetUser(ev.target.value); }} />
            </label>
            <button className="btn btn-raised btn-primary" id="searchBtn" onClick={checkUser}>Go!</button>

            {output}
          </div>
        </div>
    </div>
  )
}
export default About;